"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var icons_1 = require("@tiendanube/icons");

var useEventListener_1 = __importDefault(require("./useEventListener"));

var __1 = require("..");

require("./PullToRefresh.css");

var distance = 60;

function PullToRefresh(_a) {
  var children = _a.children,
      onRefresh = _a.onRefresh,
      loading = _a.loading;
  var data = React.useRef({
    start: {
      x: 0,
      y: 0
    },
    current: {
      x: 0,
      y: 0
    }
  });
  var container = React.useRef(null);
  var swipeStart = React.useCallback(function (e) {
    if (loading) return;

    if (typeof e.targetTouches !== "undefined") {
      var touch = e.targetTouches[0];
      data.current.start.x = touch.screenX;
      data.current.start.y = touch.screenY;
    } else {
      data.current.start.x = e.screenX;
      data.current.start.y = e.screenY;
    }
  }, [loading]);
  var swipe = React.useCallback(function (e) {
    if (loading) return;

    if (typeof e.changedTouches !== "undefined") {
      var touch = e.changedTouches[0];
      data.current.current.x = touch.screenX;
      data.current.current.y = touch.screenY;
    } else {
      data.current.current.x = e.screenX;
      data.current.current.y = e.screenY;
    }

    var changeY = data.current.start.y < data.current.current.y ? Math.abs(data.current.start.y - data.current.current.y) : 0;
    var height = changeY - window.scrollY < 0 ? 0 : changeY - window.scrollY;
    height = height > distance ? distance : height;

    if (container.current) {
      if (height === distance) {
        container.current.classList.add("rotate");
      } else {
        container.current.classList.remove("rotate");
      }

      container.current.setAttribute("style", "height: " + height + "px;");
    }
  }, [loading]);
  var swipeEnd = React.useCallback(function () {
    if (loading) return;
    var changeY = data.current.start.y < data.current.current.y ? Math.abs(data.current.start.y - data.current.current.y) : 0;
    var move = changeY - window.scrollY;

    if (container.current) {
      container.current.classList.remove("rotate");
      container.current.setAttribute("style", "height: " + 0 + "px");
    }

    if (move > distance && onRefresh) {
      onRefresh();
    }

    data.current = {
      start: {
        x: 0,
        y: 0
      },
      current: {
        x: 0,
        y: 0
      }
    };
  }, [onRefresh, loading]);
  React.useEffect(function () {
    if (container.current) {
      container.current.classList.remove("rotate");
      container.current.setAttribute("style", "height: " + 0 + "px");
    }
  }, [onRefresh]);
  useEventListener_1.default({
    eventName: "touchstart",
    handler: swipeStart
  });
  useEventListener_1.default({
    eventName: "touchmove",
    handler: swipe
  });
  useEventListener_1.default({
    eventName: "touchend",
    handler: swipeEnd
  });
  return React.createElement("div", null, loading && React.createElement("div", {
    className: "nimbus--refresh-spinner-wrapper"
  }, React.createElement(__1.Spinner, {
    size: "medium",
    appearance: "primary"
  })), React.createElement("div", {
    ref: container,
    className: "nimbus--refresh-container"
  }, React.createElement("div", {
    className: "nimbus--icon-container"
  }, React.createElement(icons_1.ChevronDownIcon, null))), children);
}

exports.default = PullToRefresh;